import { createContext, useContext } from "react";

/**
 * The bulletin row this form is writing into — the seam, split from its provider the same way
 * `state/bulletinFormContext` is split from `BulletinFormProvider`.
 *
 * The form model has no id — which bulletin this is belongs to persistence, not to the values — but the
 * media endpoints are all `/bulletin/{id}/…`, so a file cannot be uploaded before a row exists.
 */

export interface BulletinRow {
  /** The row's id once it exists, `null` while nothing has needed one. */
  id: () => number | null;
  /** Creates the row on the first call; every later call resolves to the same id. */
  ensureId: () => Promise<number>;
}

export const BulletinRowContext = createContext<BulletinRow | null>(null);

export const useBulletinRow = (): BulletinRow => {
  const row = useContext(BulletinRowContext);
  if (row === null) {
    throw new Error("useBulletinRow must be used inside BulletinFormProvider");
  }
  return row;
};
